// Workaround for react-snap (old Chromium) failing on modern selectors.
// Only applied while prerendering to avoid changing runtime behavior.
if (typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent)) {
  if (typeof window !== 'undefined' && typeof window.structuredClone !== 'function') {
    window.structuredClone = (value) => JSON.parse(JSON.stringify(value));
  }

  if (typeof window !== 'undefined' && typeof window.Stripe !== 'function') {
    window.Stripe = function StripeStub() {
      return {};
    };
  }

  const proto = typeof CSSStyleSheet !== 'undefined' ? CSSStyleSheet.prototype : null;
  if (proto && typeof proto.insertRule === 'function') {
    const originalInsertRule = proto.insertRule;
    proto.insertRule = function insertRuleSafe(rule, index) {
      try {
        return originalInsertRule.call(this, rule, index);
      } catch (error) {
        return -1;
      }
    };
  }
}
